var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3056"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 254",
    cx: 6,
    cy: 6,
    r: 2.5,
    fill: "#0079B1",
    stroke: "#0079B1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 255",
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#0079B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconEmployee);
export default __webpack_public_path__ + "static/media/mapIconEmployee.13d8d17263d2e06229d68b4021931583.svg";
export { ForwardRef as ReactComponent };